import { createFormData } from '@/shared/lib/utils/createFormData';
import { SuccessApiResponse } from '@/shared/types/common';
import { GET_ASSIGNMENT_SUBMISSION, GET_TEACHER_LESSON_SUBMISSION, rtkApi } from '@/shared/api';
import type { ISubmissionCommentRequest, ISubmissionCommentResponse } from './types';

const submissionCommentApi = rtkApi.injectEndpoints({
  endpoints: (build) => ({
    createSubmissionComment: build.mutation<
      ISubmissionCommentResponse,
      { data: ISubmissionCommentRequest; submissionId: number }
    >({
      query: ({ data, submissionId }) => ({
        url: `/submission-comments/submission/${submissionId}`,
        method: 'POST',
        body: createFormData({ ...data, clientType: 'lmsTeaching' }),
      }),
      transformResponse: (response: SuccessApiResponse<ISubmissionCommentResponse>) =>
        response.data,
      invalidatesTags: [GET_ASSIGNMENT_SUBMISSION, GET_TEACHER_LESSON_SUBMISSION],
    }),
  }),
});

export const { useCreateSubmissionCommentMutation } = submissionCommentApi;
